import * as React from "react";
import BlogCard from 'components/BlogCard';
import EventCard from 'components/EventCard';
import FeatureCard from 'components/FeatureCard';

const Card = ({data, type, ...props}) => {

	if (typeof data === 'object' && data !== null) {
		if(!data.hasOwnProperty('uri')) {
			if (data.hasOwnProperty('href') && data?.href) {
				data.uri = data.href;
			} else if (data.hasOwnProperty('link') && data?.link) {
				data.uri = data.link;
			}
		}
		if(!data.hasOwnProperty('title')) {
			if (data.hasOwnProperty('name') && data?.name) {
				data.title = data.name;
			} else if (data.hasOwnProperty('companyName') && data?.companyName) {
				data.title = data.companyName;
			}
		}
		if(!data.hasOwnProperty('photo')) {
			if (data.hasOwnProperty('image') && data?.image) {
				data.photo = data.image;
			}
		}
		if(!data.hasOwnProperty('intro')) {
			if (data.hasOwnProperty('description') && data?.description) {
				if (data.description.length > 510) {
					data.intro = `${data.description.substring(0, 510)}...`;
				} else {
					data.intro = data.description;
				}
			}
		}
	}

	if (data?.photo && !data.photo.startsWith('/')) data.photo = `/${data.photo}`;

	switch (type) {
		case 'event':
		case 'eventCard':
		case 'EventCard':
			return <EventCard {...data} />
		case 'feature':
		case 'featureCard':
		case 'FeatureCard':
			return <FeatureCard {...data} />
		case 'blog':
		case 'blogCard':
		case 'BlogCard':
			return <BlogCard {...data} />
		default:
			return <BlogCard {...data} />
	}

}

export default Card;